<template>
  <section>
    <AdminHeader
      v-if="
        $store.state.currentForm.shopname == '' ||
          $store.state.currentForm.shopname.length >= 25
      "
      v-bind:headerName="$t('newUi.forms.createForm', { form: header_name })"
      view_form=""
    />
    <AdminHeader
      v-if="
        $store.state.currentForm.shopname != '' &&
          $store.state.currentForm.shopname.length <= 25
      "
      :headerName="$store.state.currentForm.shopname"
      view_form=""
    />
    <v-overlay :value="set_overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- <GsCatelogueEditForm class="desktopView"
      v-if="state.profile.isSigned"
      v-bind:payload="payload"
    ></GsCatelogueEditForm> -->
    <div style="display:flex;justify-content: flex-end;">
      <selectLocale
        style="color: #94b978; margin-top:15px;     margin-right: 15px;"
      />
    </div>
    <CreateOrderForm
      class=""
      v-if="state.profile.isSigned"
      v-bind:payload="payload"
      :headerName="header_name"
    ></CreateOrderForm>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex";
// import GsCatelogueEditForm from "@/components/GsCatelogueEditForm";
import CreateOrderForm from "@/components/CreateOrderForm.vue";
import { loadFile, setLocale } from "../services/firebase";
import selectLocale from "../components/selectLocale";
//import store from "../store/store";
import router from "../router/router";
import AdminHeader from "@/layout/adminHeader.vue";
import i18n from "../i18n";
export default {
  data() {
    return {
      name: "",
      showMessage: false,
      set_overlay: false,
    };
  },
  components: {
    // GsCatelogueEditForm,
    CreateOrderForm,
    AdminHeader,
    selectLocale,
  },
  props: ["payload"],
  mounted() {
    if (!this.$store.state.profile.isSigned) {
      router.push("/");
    } else {
      setLocale();
      this.fetchData();
    }
  },
  watch: {
    $route: "fetchData",
  },
  computed: {
    ...mapGetters({
      user: "user",
      state: "state",
    }),
    header_name() {
      let name = "";
      if (this.payload.type == "Ordering form") {
        name = i18n.t("newUi.forms.orderNew");
      } else {
        name = i18n.t("newUi.forms.catNew");
      }
      return name;
    },
  },
  methods: {
    fetchData() {
      var store = this.$store;
      store.dispatch("setOverlay", true);
      var elethis = this;
      elethis.set_overlay = true;
      store.dispatch("setCurrentFormData", {
        id: store.state.profile.uid,
        pos: "",
        categs: ["Ordering form", "Catalogue"],
        shopname: "",
        shopdesc: "",
        type: "",
        catalogue: [],
        phone: "",
      });
      this.$store.state.currentFormPos = this.$route.params.formno;
      loadFile(
        this.$store.state.profile.uid,
        this.$route.params.formno,
        this.$store.state,
        function(error) {
          if (error) {
            //TODO skeleton data
            store.dispatch("setCurrentFormData", {
              id: store.state.profile.uid,
              pos: store.state.currentFormPos,
              categs: ["Ordering form", "Catalogue"],
              shopname: "",
              shopdesc: "",
              type: "Ordering form",
              catalogue: [],
              phone: "+919000000000",
            });
            elethis.set_overlay = false;
            store.dispatch("setOverlay", false);
          } else {
            elethis.set_overlay = false;
            store.dispatch("setOverlay", false);
          }
        }
      );
    },
  },
};
</script>
